// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"extra-field_fieldWrapper__N39LN","name":"extra-field_name__OQeYi","value":"extra-field_value__WChiT"};